// Enum representing mouse events that can be triggered by interacting with an element
export enum InteractiveMouseEvent {
  Enter = 'enter',
  Leave = 'leave',
}
